import { Component, OnInit } from '@angular/core';
import { NotificationsFacade } from '@bcmServices/notifications/notifications-facade';
import { BcmService } from '@modules/bcm/bcm.service';
import { map } from 'rxjs/operators';

@Component({
    selector: 'notifications-panel',
    templateUrl: './notifications-panel.component.html',
    styleUrls: ['./notifications-panel.component.scss'],
    standalone: false
})
export class NotificationsPanelComponent implements OnInit {

    notifications$ = this.notificationsFacade.notifications$;

    notificationsUnread$ = this.notificationsFacade.notifications$
        .pipe(map(notifications => notifications.filter(notification => !notification.status.readOn)));

    notificationsOpen = false;

    constructor(
        public notificationsFacade: NotificationsFacade,
        public bcmService: BcmService,
    ) {
    }

    ngOnInit(): void {
        this.bcmService.selectedTenant$.subscribe(selectedTenant => {
            if (selectedTenant) {
                this.notificationsFacade.loadAll().subscribe();
            } else {
                this.notificationsFacade.resetList();
            }
        });
    }
}
